import React from 'react';
import { Card, Button } from '../reusable';
import { Heading } from '../layout';
import { BarChart3 } from 'lucide-react';
import AdministrationBackLink from '../system/AdministrationBackLink';

const SectionPlaceholderPage = ({ isDarkMode, title, description: _description, showAdminBack = false }) => {
  return (
    <div>
      <Heading level={2} isDarkMode={isDarkMode}>
        <BarChart3 size={24} style={{ marginRight: '8px', verticalAlign: 'middle' }} />
        {title}
      </Heading>
      {showAdminBack ? <AdministrationBackLink /> : null}

      <Card title={title} isDarkMode={isDarkMode}>
        <div
          style={{
            padding: '40px',
            textAlign: 'center',
            color: isDarkMode ? '#a0a0a0' : '#666',
            border: `2px dashed ${isDarkMode ? '#444' : '#ddd'}`,
            borderRadius: '8px',
            backgroundColor: isDarkMode ? '#2a2a2a' : '#f9f9f9',
          }}
        >
          <BarChart3 size={48} style={{ marginBottom: '16px', opacity: 0.5 }} />
          <p style={{ margin: '0', fontSize: '16px' }}>Contenido en desarrollo</p>
          <p style={{ margin: '8px 0 0 0', fontSize: '14px', opacity: 0.7 }}>
            Esta sección usará componentes reutilizables (tablas y gráficos) al implementarse.
          </p>
        </div>

        <div style={{ marginTop: '20px', display: 'flex', gap: '8px' }}>
          <Button variant="primary" size="sm" isDarkMode={isDarkMode}>
            Actualizar
          </Button>
          <Button variant="secondary" size="sm" isDarkMode={isDarkMode}>
            Exportar
          </Button>
          <Button variant="outline" size="sm" isDarkMode={isDarkMode}>
            Configurar
          </Button>
        </div>
      </Card>
    </div>
  );
};

export default SectionPlaceholderPage;
